// TODO: we may not want to handle the versioning here but in another
// abstraction layer
export default class MqttTopic {
	static VERSION_1_PREFIX = "v1";

	static VERSION_CONSTRUCTOR_MAP = {
		[MqttTopic.VERSION_1_PREFIX]: "v1constructor"
	};

	constructor(topic) {
		if (!Array.isArray(topic)) topic = topic.split("/");

		this[MqttTopic.VERSION_CONSTRUCTOR_MAP[topic[0]]](topic);
	}

	v1constructor(topic) {
		var _; /* eslint-disable-line no-unused-vars */
		this.version = MqttTopic.VERSION_1_PREFIX;
		[
			_,
			this.category,
			this.identifier,
			this.reporter,
			this.event,
			this.type
		] = topic;
	}

	toString() {
		const v = this.version;
		if (v === MqttTopic.VERSION_1_PREFIX) this.v1toString();
		throw "Invalid MqttTopic version for toString()";
	}

	arrayToTopic(a) {
		a.filter(e => typeof e === "string").join("/");
	}

	v1toString() {
		return this.arrayToTopic([
			MqttTopic.VERSION_1_PREFIX,
			this.category,
			this.identifier,
			this.reporter,
			this.event,
			this.type
		]);
	}
}
